module.exports = __webpack_public_path__ + "img/Result_Advanced_0608_01_2.63216825.png";